<template>
  <div>
    <el-dialog
      :title="$t('text.manualSettlement')"
      :visible="isShowManualSettlementDialog"
      width="30%"
      @close="handleDialog"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item
          :label="$t('text.collectionChannel')"
          prop="channelId"
          :rules="{
            required: true,
            message: $t('message.chooseOne') + $t('text.collectionChannel'),
            trigger: 'change',
          }"
        >
          <el-select
            v-model="form.channelId"
            filterable
            :placeholder="$t('message.chooseOne')"
          >
            <el-option :label="$t('option.all')" value="all" />
            <el-option
              :key="channelId"
              v-for="{ channelName, channelId } in channelList"
              :label="channelName"
              :value="channelId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">{{ $t("text.cancel") }}</el-button>
        <el-button type="primary" @click="confirmManualSettlement">{{
          $t("text.settle")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "ManualSettlementDialog",
  props: {
    isShowManualSettlementDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      channelList: [],
      form: {
        channelId: "",
      },
    };
  },
  methods: {
    handleDialog() {
      this.$refs["form"].resetFields();
      this.form = {
        channelId: "",
      };
      this.$emit("update:isShowManualSettlementDialog", false);
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if(this.form.channelId === 'all') {
          this.form.channelId = '';
        }
        if (valid) {
          const params = {
            ...this.form,
          };
          const config = {
            headers: {
              "Content-Type": "application/json",
            },
            transformRequest: [
              function (data) {
                return JSON.stringify(data);
              },
            ],
          };
          this.$axios
            .post("/order/settlementManually", params, config)
            .then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t("text.operationSuccessful"),
                  message: this.$t("text.requestSubmittedSuccessMessage"),
                  type: "success",
                });
                this.$emit("update:isShowManualSettlementDialog", false);
                this.$bus.$emit("refresh"); //通知刷新
              } else {
                this.$notify.error({
                  title: this.$t("text.prompt"),
                  message: res.msg,
                });
              }
            });
        }
      });
    },
    confirmManualSettlement() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("text.whetherToSettle"), {
            confirmButtonText: this.$t("text.confirm"),
            cancelButtonText: this.$t("text.cancel"),
            type: "warning",
          })
            .then(() => {
              this.submit();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("text.cancel"),
              });
            });
        } else {
          return false;
        }
      });
    },
  },
  created() {
    this.$axios
      .get("/order/selectCollectChannelList", { params: {} })
      .then((res) => {
        this.channelList = res.data.sort((a, b) => {
          return a.channelName.localeCompare(b.channelName, "en", {
            sensitivity: "base",
          });
        });
      });
  },
};
</script>
